import React, { useState, useEffect } from 'react';
import DataTable from "react-data-table-component";
import { useGlobalContext } from '../GlobalContext';

const PiutangNonLunas = () => {
  const { api, isReady, periode } = useGlobalContext();
  const [piutangData, setPiutangData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedJenis, setSelectedJenis] = useState("A");

  useEffect(() => {
    if (isReady) {
      getPiutangNonLunas();
    }
  }, [isReady, selectedJenis]);

  const getPiutangNonLunas = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/api/piutang/getpiutangall/${selectedJenis}`);
      const newData = response.data.data || [];
      setPiutangData(newData);
      console.log("Data Piutang Non Lunas:", newData);
    } catch (error) {
      console.error('Error get piutang non lunas:', error.response?.data || error.message);
      setPiutangData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleJenisChange = (e) => {
    setSelectedJenis(e.target.value);
  };

  const filteredData = piutangData.filter(item =>
    item.nama?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.noanggota?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.norealisasi?.toLowerCase().includes(searchText.toLowerCase())
  );

  const formatRupiah = (number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(number);
  };

  const columns = [
    {
      name: "Nomor",
      selector: (row, index) => index + 1,
      width: "60px",
      center: true,
    },
    {
      name: 'No. Realisasi',
      selector: row => row.norealisasi,
      sortable: true,
    },
    {
      name: 'No. Anggota',
      selector: row => row.noanggota,
      sortable: true,
      width: "120px",
      center: true,
    },
    {
      name: 'Nama Anggota',
      selector: row => row.nama,
      sortable: true,
    },
    {
      name: 'Pelayanan',
      selector: row => row.pelayanan,
      sortable: true,
      width: "120px",
    },
    {
      name: 'Kembali',
      selector: row => formatRupiah(row.kembali || 0),
      sortable: true,
      right: true,
      width: "150px",
    },
    {
      name: 'Saldo Piutang',
      selector: row => formatRupiah(row.sldpiutang || 0),
      sortable: true,
      right: true,
      width: "150px",
    },
  ];

  return (
    <div>
      {/* Content Header */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="content">
        <div className="container-fluid">
          {/* Card Tabel */}
          <div className="row">
            <div className="col-md-12">
              <div className="card card-info">
                <div className="card-header with-border">
                  <h3 className="card-title">
                    piutang non lunas
                  </h3>
                </div>

                <div className="card-body">
                  {/* Filter Section */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="jenispiutang" className="form-label"><strong>Jenis Piutang</strong></label>
                        <select
                          id="jenispiutang"
                          className="form-control form-control-sm"
                          value={selectedJenis}
                          onChange={handleJenisChange}
                        >
                          <option value="A">piutang A</option>
                          <option value="B">piutang B</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* DataTable */}
                  <div style={{ overflowX: 'auto' }}>
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[10, 20, 50, 100]}
                      progressPending={loading}
                      striped
                      dense
                      highlightOnHover
                      responsive
                      noDataComponent={
                        <div style={{ padding: '30px', textAlign: 'center', color: '#999' }}>
                          Tidak ada data piutang non lunas
                        </div>
                      }
                      customStyles={{
                        headCells: {
                          style: {
                            fontWeight: 'bold',
                            fontSize: '14px',
                            backgroundColor: '#f0f0f0',
                            padding: '12px 8px',
                            borderRight: '1px solid #ddd',
                          },
                        },
                        cells: {
                          style: {
                            borderRight: '1px solid #ddd',
                            padding: '10px 8px',
                            fontSize: '13px',
                          },
                        },
                        rows: {
                          style: {
                            borderBottom: '1px solid #eee',
                          },
                        },
                      }}
                    />
                  </div>
                </div>

                <div className="card-footer">
                  <small className="text-muted">
                    Total Data: <strong>{filteredData.length}</strong> | Periode: <strong>{periode}</strong>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PiutangNonLunas;
